import Vue from 'vue'
import Vuex from 'vuex'
import professionalModeService from "./service/professionalModeService";
Vue.use(Vuex);

var state = {
    isProfessionalMode: professionalModeService.getState(),
    userId: localStorage.getItem('userId'),
    username: localStorage.getItem('username'),
    auth_userId: localStorage.getItem('auth_userId'),
    auth_timestamp: localStorage.getItem('auth_timestamp')
};

var getters = {
    isProfessionalMode(state){
        return professionalModeService.getState()
    },
    userId(state){
        return state.userId
    },
    username(state){
        return state.username
    },
    auth_userId(state){
        return state.auth_userId
    },
    auth_timestamp(state){
        return state.auth_timestamp
    },
};

const actions = {
    setIsProfessionalMode(context,flag){
        context.commit('mutationsSetIsProfessionalMode',flag);
    },
    getIsProfessionalMode({commit,state}){
        commit('setIsProfessionalMode');
    },
    getUserId({commit,state}){
        commit('setUserId');
    },
    getUsername({commit,state}){
        commit('setUsername');
    },
    getAuth_userId({commit,state}){
        commit('setAuth_userId');
    },
    getAuth_timestamp({commit,state}){
        commit('setAuth_timestamp');
    },
};

const mutations= {
    // setIsProfessionalMode (state,isProfessionalMode) {
    //     state.isProfessionalMode = isProfessionalMode;
    //     professionalModeService.toggle(isProfessionalMode);
    // },
    mutationsSetIsProfessionalMode(state,isProfessionalMode){
        state.isProfessionalMode = isProfessionalMode;
    },
    setUserId (state,userId) {
        state.userId = userId;
    },
    setUsername (state,username) {
        state.username = username;
    },
    setAuth_userId (state,auth_userId) {
        state.auth_userId = auth_userId;
    },
    setAuth_timestamp (state,auth_timestamp) {
        state.auth_timestamp = auth_timestamp;
    }
};

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
});

export default store
